export const GET_DND_SUCCESS = 'GET_DND_SUCCESS';
export const GET_DND_COUNT_SUCCESS = 'GET_DND_COUNT_SUCCESS';
export const DND_TOGGLE_FLAG = 'DND_TOGGLE_FLAG';

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
